import React, { useState } from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {SelectField} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";

const SubCompanyTypeFilter = () => {
    const {t} = useTranslation();
    const stores = useStore();

    const handleSubcompanyType = (value) => {
        stores.meStore.map.filters.disabled = value;
    };


    return useObserver(() => (
        <React.Fragment>
            <h5>Alt firma türü</h5>
            <SelectField
                value={stores.meStore.map.filters.disabled}
                data-testid="activityFilter"
                onChange={value => {
                    handleSubcompanyType(value);
                }}
            >
                <SelectField.Option value="all" data-testid="activityFilter_option">
                    {t("filters.all", {ns: "common"})}
                </SelectField.Option>
                <SelectField.Option value="false" data-testid="activityFilter_option">
                    {t("activeCompanies", {ns: "companyPage"})}
                </SelectField.Option>
                <SelectField.Option value="true" data-testid="activityFilter_option">
                    {t("inactiveCompanies", {ns: "companyPage"})}
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    ));
};

export default SubCompanyTypeFilter;
